import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { withAccount } from '../../components/AccountContext';
import JPSResondentDetail from './JPSResondentDetail';
import { Loading } from '../../components/Loading';
import { matchShape } from '../../components/prop-types';

export const JPS_RESPONDENT_QUERY = gql`
  query($accountId: ID!, $id: ID!) {
    account(id: $accountId) {
      id
      jobProfileSurvey(id: $id) {
        id
        locale
        startedOn
        status
        respondent {
          id
          firstName
          lastName
        }
        startUrl
        previewInviteUrl
        previewReminderUrl
        createdOn
        invitedOn
        remindedOn
        declinedOn
        updatedOn
        expiredOn
        submittedOn
        jobProfile {
          id
          template: assessmentTemplate {
            id
            title
          }
        }
      }
    }
  }
`;

const JPSDetailContainer = (props) => {
  const { match: { params }, currentAccount } = props;
  const { jpsRespondentId } = params;
  const variables = {
    accountId: currentAccount,
    id: jpsRespondentId,
  };

  return (
    <Query query={JPS_RESPONDENT_QUERY} variables={variables}>
      {({ loading, error, data }) => {
        if (loading) return <Loading />;
        if (error) return `Error! ${error.message}`;
        return (
          <JPSResondentDetail data={data.account} />
        );
      }}
    </Query>
  );
};

JPSDetailContainer.propTypes = {
  match: matchShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withRouter(
  withAccount(
    JPSDetailContainer,
  ),
);
